import { Component } from '@angular/core';
import { IconeDirective } from '../../../directives/icone.directive';
import { navegaAoTopo } from '../../../../core/utils/utils';

@Component({
    selector: 'app-botao-navega-ao-topo',
    standalone: true,
    imports: [IconeDirective],
    template: `
        <button appIcone="chevron-up" aria-label="Voltar ao topo da página" (click)="aoClicarNavegaAoTopo()"></button>
    `,
    styleUrl: './botao-navega-ao-topo.component.scss',
})
export class BotaoNavegaAoTopoComponent {
    public aoClicarNavegaAoTopo(): void {
        navegaAoTopo();
    }
}
